export const selectBulkOrderState = (state) => state.bulkOrder || {};
export const selectLoading = (state) =>selectBulkOrderState(state).loading || false;
export const selectError = (state) => selectBulkOrderState(state).error;
export const selectUploadSuccess = (state) =>selectBulkOrderState(state).uploadSuccess || false;
